const { Entity } = require('./entity')

class Account extends Entity {
  constructor (quickbooks, query) {
    super(quickbooks, 'Account')
    this.query = query
  }

  /**
   * @param {string[]} accountIds
   * @param {string} companyCode
   */
  getList (accountIds, companyCode) {
    if (!accountIds || !accountIds.length) {
      return []
    }

    return this.query.send({
      companyCode,
      type: 'Account',
      where: `Id in (${[...accountIds].map(id => `'${id}'`).join(',')}) and active in (false, true)`,
      maxResults: 500
    })
  }
}

module.exports = {
  Account
}
